import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWeight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="weight, scale"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M9.375 12.1225L6.75 8.84129C8.18836 7.68911 10.0137 7 12 7C13.9863 7 15.8116 7.68911 17.25 8.84129L14.625 12.1225C13.9058 11.5465 12.9931 11.2019 12 11.2019C11.0069 11.2019 10.0942 11.5465 9.375 12.1225Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconWeight;
